import { BaseDocument } from './BaseDocument';
import { firestore } from 'firebase/app';
import { EntrySchema } from '../schemas/Patient';

export class EntryDocument extends BaseDocument<EntrySchema> {
    constructor(snapshot: firestore.DocumentSnapshot<EntrySchema>) {
        super(snapshot, 'Entry');
    }
}
